<template>
  <div class="row">

    <div class="col-xs-8 offset-xs-2 col-md-8 offset-md-2 col-sm-12">
      <ValidationObserver v-slot="{ handleSubmit }" ref="formValidator">

        <card>
          <div slot="header">
            <h4 class="card-title">
              {{ formTitle }}
            </h4>
          </div>

          <div class="card-body">

            <ValidationProvider
              vid="old_password"
              rules="required"
              name="The Old Password"
              v-slot="{ passed, failed,errors }"
            >
              <fg-input type="password"
                        :error="failed ? errors[0]: null"
                        :hasSuccess="passed"
                        label="Old Password"
                        v-model="formData.old_password">
              </fg-input>
            </ValidationProvider>

            <ValidationProvider
              vid="new_password"
              :rules="passVal"
              name="The New Password"
              v-slot="{ passed, failed,errors }"
            >
              <fg-input type="password"
                        :error="failed ? errors[0]: null"
                        :hasSuccess="passed"
                        label="New Password"
                        v-model="formData.new_password">
              </fg-input>
            </ValidationProvider>

            <ValidationProvider
              rules="required|confirmed:new_password"
              name="The Confirmed Password"
              v-slot="{ passed, failed ,errors}">
              <fg-input type="password"
                        :error="failed ? errors[0]: null"
                        :hasSuccess="passed"
                        label="Confirm Password"
                        name="confirm"
                        v-model="formData.confirmed_password">
              </fg-input>

            </ValidationProvider>

          </div>

          <div class="card-footer text-right">
            <l-button :disabled="submitting" @click.prevent="handleSubmit(submit)" nativeType="submit"
                      type="info" wide>Submit
            </l-button>&nbsp;
            <l-button @click="$router.push('/')" type="danger" wide>Cancel
            </l-button>
          </div>
        </card>
      </ValidationObserver>

    </div>

  </div>
</template>
<script>
import {extend} from "vee-validate";
import {required, confirmed, min, regex} from "vee-validate/dist/rules";

extend("confirmed", confirmed);
extend("required", required);
extend("min",{...min,message:'the password must be 8 character or more'});
extend("regex",{...regex,message:'Password requires 1 of each of the following: uppercase letter, lowercase letter, number.'});



export default {

  data() {
    return {
      formTitle: "Update Password",
      submitting: false,
      formData: {
        old_password: "",
        new_password: "",
        confirmed_password: "",
      },
      passVal:{required: true,min: 8,regex: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).*$' }
    };
  },


  methods: {
    submit() {
      this.submitting = true;
      this.axios.post("auth/change-my-password", this.formData)
        .then((response) => {
          this.$notify({
            message: "Password Updated Successfully",
            timeout: 1000,
            type: 'success'
          })
          this.$router.push("/");
        }).catch((error) => {
        if (error.response.status === 422) {
          this.$refs.formValidator.setErrors(error.response.data.errors);
        } else {
          console.log(error.response)
        }
      }).finally(() => {
        this.submitting = false;
      });
    }
  }
}
</script>

<style>
</style>
